import { Color } from '../../color.model';

export const grass: Color = {
  light: {
    1: 'hsl(116, 50.0%, 98.9%)',
    2: 'hsl(120, 60.0%, 97.1%)',
    3: 'hsl(120, 53.6%, 94.8%)',
    4: 'hsl(121, 47.5%, 91.4%)',
    5: 'hsl(122, 42.6%, 86.5%)',
    6: 'hsl(124, 39.0%, 79.7%)',
    7: 'hsl(126, 37.1%, 70.2%)',
    8: 'hsl(131, 38.1%, 56.3%)',
    9: 'hsl(131, 41.0%, 46.5%)',
    10: 'hsl(132, 43.1%, 42.2%)',
    11: 'hsl(133, 50.0%, 32.5%)',
    12: 'hsl(130, 30.0%, 14.9%)',
  },
  dark: {
    1: 'hsl(146, 30.0%, 7.4%)',
    2: 'hsl(136, 33.3%, 8.8%)',
    3: 'hsl(137, 36.0%, 11.4%)',
    4: 'hsl(137, 37.6%, 13.7%)',
    5: 'hsl(136, 38.7%, 16.0%)',
    6: 'hsl(135, 39.6%, 19.1%)',
    7: 'hsl(134, 40.3%, 23.8%)',
    8: 'hsl(131, 40.1%, 30.8%)',
    9: 'hsl(131, 41.0%, 46.5%)',
    10: 'hsl(131, 39.0%, 52.1%)',
    11: 'hsl(131, 43.0%, 57.2%)',
    12: 'hsl(137, 72.0%, 94.0%)',
  },
};
